/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { CSG } from '../../../../../../assets/libs/csg-lib';
import { const_var, params } from '../../../../../../redux/reducers/reducer'
import { setWallCloseStateWrap } from '../../../../../../action';
import { delModel, extrudeSettings, jTrimModel, textureAnisotropy, wainscotTrimModel } from '../../../../../../utils/Functions';
import { controls } from '../../../../../../redux/reducers/common/eventReducer';
import { MaterialTrim, MaterialWainScotTrim, MaterialWainScotTrimNew } from '../../../../CustomMaterial';
import { useThree } from '@react-three/fiber';

const TrimModel = () => {
    const dispatch = useDispatch();
    const { gl } = useThree();
    const wallCloseStateWrap = useSelector(state => state.reducer.wallCloseStateWrap)

    const [wallCloseState, setWallCloseState] = useState(0);
    const [leftStorageWallHeight, setLeftStorageWallHeight] = useState(params.p_h);
    const [rightStorageWallHeight, setRightStorageWallHeight] = useState(params.p_h);
    // const [CSGJTrimModelGeometry, setCSGJTrimModelGeometry] = useState(null);
    // const [CSGwainscotTrimModelGeometry, setCSGwainscotTrimModelGeometry] = useState(null);    

    // const wainscotColor = useMemo(() => {
    //     if ((const_var.activeTab === 'doorwindow' && const_var.focusedSection !== 'center' && const_var.focusedSection !== '') || (params.is_translusant)) {
    //         return 'white'
    //     } else {
    //         return params.p_w_c_c.replace("0x","#");
    //     }
    // }, [params.p_w_c_c, const_var.activeTab, const_var.focusedSection, params.is_translusant])    
    const wainscotColor = useMemo(() => (params.p_w_c_c.replace("0x","#")), [params.p_w_c_c]) 
    
    const leftHeight = useMemo(() => ((params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) :  params.p_h), [params.singleSlope, params.freeStandingSide, params.p_w, params.p_h, params.p_r_p])

    const leftTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }
        // if (wallCloseStateWrap.LLBackWallCloseState && wallCloseStateWrap.LLBackWallCloseState > -1) {
        if(params.leanStyle.left === 'standard'){
            if (!params.add_left_lean && (params.cB_addStorage_check_left)) {
                model.moveTo(-(params.p_w / 2 + 0.075), 0);
                model.lineTo(-(params.p_w / 2 + 0.075), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_w / 2 - 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_w / 2 - 0.15), 0);
                model.closePath();
            } else {
                if((params.add_left_lean && params.leantoAlignmentLeft == 3 && !(params.p_b_c_b_l_b === 'Open'))
                    || (params.add_left_lean && params.leantoAlignmentLeft == 1 && !(params.p_b_c_b_l_b === 'Open') && params.p_d === params.lean_p_d)
                ){
                    if (wallCloseState > -1 && !params.cB_addStorage_check_left && wallCloseStateWrap.LLBackWallCloseState !== undefined && params.p_b_c_b_l_b !== 'Close') {
                        model.moveTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLBackWallCloseState);
                        model.lineTo(-(params.p_w / 2 + 0.075), wallCloseState);
                        model.lineTo(-(params.p_w / 2 - 0.15), wallCloseState);
                        model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLBackWallCloseState);
                        model.closePath();
                    } 
                } else{
                    if (wallCloseState > -1 ) {
                        model.moveTo(-(params.p_w / 2 + 0.075), wallCloseState);
                        model.lineTo(-(params.p_w / 2 + 0.075), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                        model.lineTo(-(params.p_w / 2 - 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                        model.lineTo(-(params.p_w / 2 - 0.15), wallCloseState);
                        model.closePath();
                    }
                }
            }
        } else {
            if (!params.add_left_lean && (params.cB_addStorage_check_left)) {
                model.moveTo(-(params.p_w / 2 + 0.075), 0);
                model.lineTo(-(params.p_w / 2 + 0.075), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_w / 2 - 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_w / 2 - 0.15), 0);
                model.closePath();
            } else {
                if((params.add_left_lean && params.leantoAlignmentLeft == 3 && (!(params.p_b_c_b_l === 'Open') || (params.add_storage_check && params.leftLeanStoragePosition === 0)))
                    || (params.add_left_lean && params.leantoAlignmentLeft == 1 && (!(params.p_b_c_b_l === 'Open') || (params.add_storage_check && params.leftLeanStoragePosition === 0)) && params.p_d === params.lean_p_w)
                ){
                    let leftWallCloseState = (params.add_storage_check && params.leftLeanStoragePosition === 0) ? 0 : wallCloseStateWrap.LLLeftWallCloseState;
                    if (wallCloseState > -1 && !params.cB_addStorage_check_left && leftWallCloseState !== undefined) {
                        if (wallCloseState < wallCloseStateWrap.cbLeftWallCloseState) {
                            model.moveTo(-(params.p_w / 2 + 0.075), leftWallCloseState);
                            model.lineTo(-(params.p_w / 2 + 0.075), wallCloseState);
                            model.lineTo(-(params.p_w / 2 - 0.15), wallCloseState);
                            model.lineTo(-(params.p_w / 2 - 0.15), leftWallCloseState);
                            model.closePath();
                        } else {
                            model.moveTo(-(params.p_w / 2 + 0.075), Math.max(wallCloseState, leftWallCloseState));
                            model.lineTo(-(params.p_w / 2 + 0.075),  Math.min(leftWallCloseState, wallCloseStateWrap.cbLeftWallCloseState));
                            model.lineTo(-(params.p_w / 2 - 0.15),  Math.min(leftWallCloseState, wallCloseStateWrap.cbLeftWallCloseState));
                            model.lineTo(-(params.p_w / 2 - 0.15), Math.max(wallCloseState, leftWallCloseState));
                            model.closePath();
                        }
                    } 
                } else{
                    if (wallCloseState > -1 ) {
                        model.moveTo(-(params.p_w / 2 + 0.075), wallCloseState);
                        model.lineTo(-(params.p_w / 2 + 0.075), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                        model.lineTo(-(params.p_w / 2 - 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                        model.lineTo(-(params.p_w / 2 - 0.15), wallCloseState);
                        model.closePath();
                    }
                }
            }
        }

        return model;
    
    }, [params.p_d,params.p_h, wallCloseState, params.leanStyle.left, params.p_w, params.p_r_p, params.p_r_s, params.p_r_p, params.cB_addStorage_check_left,params.singleSlope && params.freeStandingSide === "left", params.leantoAlignmentLeft, params.add_left_lean, params.p_b_c_b_l_b, params.p_d, params.lean_p_d, wallCloseStateWrap.LLBackWallCloseState, wallCloseStateWrap.LLLeftWallCloseState, wallCloseStateWrap.cbLeftWallCloseState, params.add_storage_check, params.leftLeanStoragePosition])

    const rightTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        
        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if (!params.add_right_lean && (params.cB_addStorage_check_right)) {
            model.moveTo(params.p_w / 2 - 0.15, 0);
            model.lineTo(params.p_w / 2 - 0.15, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
            model.lineTo(params.p_w / 2 + 0.075, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
            model.lineTo(params.p_w / 2 + 0.075, 0);
            model.closePath();
        } else if((params.leanStyle.right === 'standard') && ((params.add_right_lean && params.leantoAlignmentRight == 3 && !(params.p_b_c_b_r_b === 'Open'))
            || (params.add_right_lean && params.leantoAlignmentRight == 1 && !(params.p_b_c_b_r_b === 'Open') && params.p_d === params.leanR_p_d))
        ){
            if (wallCloseState > -1 && !params.cB_addStorage_check_right) {
                if (params.p_b_c_b_b_f !== 'Open' && wallCloseStateWrap.LLFrontWallCloseState <= wallCloseStateWrap.BLFrontWallCloseState && wallCloseState >= wallCloseStateWrap.BLFrontWallCloseState) {
                    model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLBackWallCloseState);
                    model.lineTo((params.p_w / 2 + 0.075), wallCloseStateWrap.BLFrontWallCloseState);
                    model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.BLFrontWallCloseState);
                    model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLBackWallCloseState);
                    model.closePath();
                } else {
                    model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLBackWallCloseState + (params.p_r_s === 1 && params.p_b_c_b_r_b === 'Gable' ? 0.36 : 0.1));
                    model.lineTo((params.p_w / 2 + 0.075), wallCloseState);
                    model.lineTo((params.p_w / 2 - 0.15), wallCloseState);
                    model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLBackWallCloseState + (params.p_r_s === 1 && params.p_b_c_b_r_b === 'Gable' ? 0.36 : 0.1));
                    model.closePath();
                }
            }
        } else if((params.leanStyle.right !== 'standard') && ((params.add_right_lean && params.leantoAlignmentRight == 3 && (params.p_b_c_b_r_r !== 'Open' || (params.add_storage_check_right && params.rightLeanStoragePosition === 0)))
            || (params.add_right_lean && params.leantoAlignmentRight !== 3 && (params.p_b_c_b_r_r !== 'Open' || (params.add_storage_check_right && params.rightLeanStoragePosition === 0)) && params.p_d === params.leanR_p_w))
        ){

            if (params.add_storage_check_right && params.rightLeanStoragePosition === 0){
                model.moveTo((params.p_w / 2 + 0.075), params.leanR_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.lineTo((params.p_w / 2 + 0.075), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo((params.p_w / 2 - 0.15), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo((params.p_w / 2 - 0.15), params.leanR_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.closePath();
            } else if (wallCloseState > -1) {
                model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLRightWallCloseState + 0.1);
                model.lineTo((params.p_w / 2 + 0.075), wallCloseState);
                model.lineTo((params.p_w / 2 - 0.15), wallCloseState);
                model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLRightWallCloseState + 0.1);
                model.closePath();
            }
                
            
        }  
        else {
            if (wallCloseState > -1) {    
                model.moveTo(params.p_w / 2 - 0.15, wallCloseState);
                model.lineTo(params.p_w / 2 - 0.15, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(params.p_w / 2 + 0.07, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(params.p_w / 2 + 0.07, wallCloseState);
                model.closePath();
            }
        }

        return model;
    
    }, [params.p_d,params.p_h, wallCloseState, params.p_w, params.p_r_p, params.p_r_s, params.p_b_c_b_b_f, params.cB_addStorage_check_right, params.singleSlope, params.leantoAlignmentRight, params.add_right_lean, params.p_b_c_b_r_b, params.p_b_c_b_r_r, wallCloseStateWrap.RLRightWallCloseState, params.leanR_p_d, wallCloseStateWrap.RLBackWallCloseState, wallCloseStateWrap.BLFrontWallCloseState, params.add_storage_check_right, params.rightLeanStoragePosition])

    const leftLeanRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if (wallCloseStateWrap.LLBackWallCloseState !== undefined && wallCloseStateWrap.LLBackWallCloseState > -1) {
            if((params.add_left_lean && params.leantoAlignmentLeft == 3 && !(params.p_b_c_b_l_b === 'Open'))
                || (params.add_left_lean && params.leantoAlignmentLeft == 1 && params.p_d === params.lean_p_d && !(params.p_b_c_b_l_b === 'Open'))){
  
                if (wallCloseState > -1) {
                    if(!params.cB_addStorage_check_left){
                        if (params.p_b_c_b_b_b !== 'Open' && wallCloseStateWrap.LLFrontWallCloseState <= wallCloseStateWrap.BLBackWallCloseState && wallCloseState >= wallCloseStateWrap.BLBackWallCloseState) {
                            model.moveTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLBackWallCloseState);
                            model.lineTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.BLBackWallCloseState);
                            model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.BLBackWallCloseState);
                            model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLBackWallCloseState);
                            model.closePath();
                        } else {
                            model.moveTo(-(params.p_w / 2 + 0.075), wallCloseState);
                            model.lineTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLBackWallCloseState + 0.1);
                            model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLBackWallCloseState + 0.1);
                            model.lineTo(-(params.p_w / 2 - 0.15), wallCloseState);
                            model.closePath();
                        }
                    }
                    
                } 
                // else {
                //     model.moveTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLBackWallCloseState);
                //     model.lineTo(-(params.p_w / 2 + 0.075), params.p_h);
                //     model.lineTo(-(params.p_w / 2 - 0.15), params.p_h);
                //     model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLBackWallCloseState);
                //     model.closePath();
                // }
            }
        }
        return model;
    
    }, [params.p_h, wallCloseState, params.p_w, params.p_r_p, params.p_r_s, params.p_r_p, params.p_b_c_b_b_b, params.cB_addStorage_check_left,params.singleSlope && params.freeStandingSide === "left", params.leantoAlignmentLeft, params.add_left_lean, params.p_b_c_b_l_b, wallCloseStateWrap.LLBackWallCloseState, wallCloseStateWrap.BLBackWallCloseState, params.p_f_w, params.p_d, params.lean_p_d])

    const RightLeanLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if (wallCloseStateWrap.RLBackWallCloseState !== undefined && wallCloseStateWrap.RLBackWallCloseState > -1) {
            if((params.add_right_lean && params.leantoAlignmentRight == 3 && !(params.p_b_c_b_r_b === 'Open'))
                || (params.add_right_lean && params.leantoAlignmentRight == 1 && params.p_d === params.leanR_p_d && !(params.p_b_c_b_r_b === 'Open'))){

                if (wallCloseState > -1) {
                    if(!params.cB_addStorage_check_right){
                        if (params.p_b_c_b_b_f !== 'Open' && wallCloseStateWrap.LLFrontWallCloseState <= wallCloseStateWrap.BLFrontWallCloseState && wallCloseState >= wallCloseStateWrap.BLFrontWallCloseState) {
                            model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLBackWallCloseState);
                            model.lineTo((params.p_w / 2 + 0.075), wallCloseStateWrap.BLFrontWallCloseState);
                            model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.BLFrontWallCloseState);
                            model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLBackWallCloseState);
                            model.closePath();
                        } else {
                            model.moveTo((params.p_w / 2 + 0.075), wallCloseState);
                            model.lineTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLBackWallCloseState + 0.1);
                            model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLBackWallCloseState + 0.1);
                            model.lineTo((params.p_w / 2 - 0.15), wallCloseState);
                            model.closePath();
                        }
                    }
                } 
                // else {
                //     model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLBackWallCloseState);
                //     model.lineTo((params.p_w / 2 + 0.075), params.p_h);
                //     model.lineTo((params.p_w / 2 - 0.15), params.p_h);
                //     model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLBackWallCloseState);
                //     model.closePath();
                // }
            }
        }
        return model;
    
    }, [params.p_h, wallCloseState, params.p_w, params.p_r_p, params.p_r_s, params.p_r_p, params.p_b_c_b_b_f, params.cB_addStorage_check_left,params.singleSlope && params.freeStandingSide === "left", params.leantoAlignmentRight, params.add_right_lean, params.p_b_c_b_r_b, wallCloseStateWrap.RLBackWallCloseState, wallCloseStateWrap.BLFrontWallCloseState, params.p_f_w, params.p_d, params.leanR_p_d])
    
    const connectLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if (wallCloseStateWrap.cbLeftWallCloseState !== undefined && wallCloseStateWrap.LLBackWallCloseState !== undefined && (params.p_d === params.lean_p_d || params.leantoAlignmentLeft === 3)) {
            if((params.add_left_lean && !(params.p_b_c_b_l_b === 'Open') && (wallCloseStateWrap.cbLeftWallCloseState <= wallCloseStateWrap.LLBackWallCloseState) && (wallCloseStateWrap.cbLeftWallCloseState <= wallCloseState))
                || (params.add_left_lean && !(params.p_b_c_b_l_b === 'Open') && params.p_b_w === 'Open' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right))){
                    model.moveTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.cbLeftWallCloseState);
                    model.lineTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLBackWallCloseState + 0.1);
                    model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLBackWallCloseState + 0.1);
                    model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.cbLeftWallCloseState);
                    model.closePath();
            }
        }
        return model;
    
    }, [wallCloseStateWrap.cbLeftWallCloseState, params.p_w, wallCloseStateWrap.LLBackWallCloseState, params.add_left_lean, params.p_b_c_b_l_b, wallCloseState, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.p_b_w === 'Open', params.lean_p_d, params.leantoAlignmentLeft])

    const connectRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if (wallCloseStateWrap.cbRightWallCloseState !== undefined && wallCloseStateWrap.RLBackWallCloseState !== undefined && (params.p_d === params.leanR_p_d || params.leantoAlignmentRight === 3)) {
            if((params.add_right_lean && !(params.p_b_c_b_r_b === 'Open') && (wallCloseStateWrap.cbRightWallCloseState <= wallCloseStateWrap.RLBackWallCloseState) && (wallCloseStateWrap.cbRightWallCloseState <= wallCloseState))
                || (params.add_right_lean && !(params.p_b_c_b_r_b === 'Open') && params.p_b_w === 'Open' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right))){    
                    model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.cbRightWallCloseState);
                    model.lineTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLBackWallCloseState + 0.1);
                    model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLBackWallCloseState + 0.1);
                    model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.cbRightWallCloseState);
                    model.closePath();
            }
        }
        return model;
    
    }, [wallCloseStateWrap.cbRightWallCloseState, params.p_w, wallCloseStateWrap.RLBackWallCloseState, params.add_right_lean, params.p_b_c_b_r_b, wallCloseState, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.p_b_w === 'Open', params.leanR_p_d, params.leantoAlignmentRight])

    const leftStorageTrimModelOne = useMemo(() => {
        const model = new THREE.Shape();
        
        if (params.cB_addStorage_check_left) {
            model.moveTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.18, 0);

            if (wallCloseState > -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.18, wallCloseState + (params.p_j_t_end ? 0.1 : 0));
            }
    
            if (wallCloseState === -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.18, leftStorageWallHeight - 0.1);
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, leftStorageWallHeight - 0.1);
            }

            if (wallCloseState > -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, wallCloseState + (params.p_j_t_end ? 0.1 : 0));
            }

            model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, 0);
            model.closePath();
        }

        return model;
    
    }, [wallCloseState, params.p_w, params.p_r_p, params.cB_addStorage_check_left, params.cB_addStorage_left, leftStorageWallHeight, params.p_j_t_end])

    const leftStorageTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        
        if (params.cB_addStorage_check_left) {
            model.moveTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);

            if (wallCloseState > -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), wallCloseState);
            }
    
            if (wallCloseState === -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), leftStorageWallHeight - 0.1);
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, leftStorageWallHeight - 0.1);
            }

            if (wallCloseState > -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, wallCloseState);
            }

            model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, 0);
            model.closePath();
        }

        return model;
    
    }, [wallCloseState, params.p_w, params.p_r_p, params.cB_addStorage_check_left, params.cB_addStorage_left, leftStorageWallHeight])

    const rightStorageTrimModelOne = useMemo(() => {
        const model = new THREE.Shape();
        
        if (params.cB_addStorage_check_right) {
            model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, 0);

            if (wallCloseState > -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, wallCloseState + (params.p_j_t_end ? 0.1 : 0));
            }
    
            if (wallCloseState === -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, rightStorageWallHeight - 0.1);
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) + 0.18, rightStorageWallHeight - 0.1);
            }

            if (wallCloseState > -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) + 0.18, wallCloseState + (params.p_j_t_end ? 0.1 : 0));
            }

            model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) + 0.18, 0);
            model.closePath();
        }

        return model;
    
    }, [wallCloseState, params.p_w, params.p_r_p, params.cB_addStorage_check_right, params.cB_addStorage_right, rightStorageWallHeight, params.p_j_t_end])

    const rightStorageTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        
        if (params.cB_addStorage_check_right) {
            model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, 0);

            if (wallCloseState > -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, wallCloseState);
            }
    
            if (wallCloseState === -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, rightStorageWallHeight - 0.1);
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), rightStorageWallHeight - 0.1);
            }

            if (wallCloseState > -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), wallCloseState);
            }

            model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0);
            model.closePath();
        }

        return model;
    
    }, [wallCloseState, params.p_w, params.p_r_p, params.cB_addStorage_check_right, params.cB_addStorage_right, rightStorageWallHeight])

    const dutchDelModel = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        const cornerFreeSpaceW = freeSpace * 2;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = cornerFreeSpaceW;
        
        if (!params.cB_addStorage_check_right && !params.cB_addStorage_check_right && (params.p_b_w === "Half Dutch End" || params.p_b_w === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.p_w / 2 - freeSpace), 0);

            if (params.p_b_w === "Half Dutch End") {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.p_w / 2 - freeSpace), 0);
                model.lineTo((params.p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), 0);
                model.lineTo((params.p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.p_w, params.p_h, params.p_b_w, params.cB_addStorage_check_right , params.cB_addStorage_check_left])
    
    /**********************cutting hole using CSG************************/
    const mainTrimModel = useMemo(() => {

        const storageDelShape = new THREE.Shape();
            if(params.cB_addStorage_check_left) {
                storageDelShape.moveTo(-params.p_w / 2 - 0.075, 0);
                storageDelShape.lineTo(-params.p_w / 2 - 0.075, params.p_h);
                storageDelShape.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), params.p_h)
                storageDelShape.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                storageDelShape.closePath();

            } else if(params.cB_addStorage_check_right) {
                storageDelShape.moveTo(params.p_w / 2 + 0.075, 0);
                storageDelShape.lineTo(params.p_w / 2 + 0.075, params.p_h);
                storageDelShape.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), params.p_h)
                storageDelShape.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0);
                storageDelShape.closePath();
            }


        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.p_w + 0.15)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('back', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))
        const meshStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageDelShape, extrudeSettings(1)))

        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.rotation.y = Math.PI/2
        meshJTrimModel_Temp.position.set(-(params.p_w / 2 + 0.075), wallCloseState + 0.1, -(params.p_d / 2 + 0.1525));
        meshJTrimModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(0, 0, -(params.p_d / 2 + 0.5));
        meshDelModel_Temp.updateMatrixWorld();

        const meshStorageDelModel_Temp = meshStorageDelModel.clone();
        meshStorageDelModel_Temp.position.set(0, 0, -params.p_d / 2 - 0.5)
        meshStorageDelModel_Temp.updateMatrixWorld();

        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshStorageDelModel_CSG = CSG.fromMesh(meshStorageDelModel_Temp);

        const JTrimModel_CSG = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const StorageDelModel_CSG = JTrimModel_CSG.subtract(meshStorageDelModel_CSG);

        const CSGJTrimModel = CSG.toMesh(
            StorageDelModel_CSG,
            new THREE.Matrix4()
        )
        
        
        /**********************cutting hole using CSG for Wainscot Trim************************/
        const leftStorageWidth = (params.cB_addStorage_check_left && params.p_b_w !== "Close") ? params.p_w - params.cB_addStorage_left : 0
        const rightStorageWidth = (params.cB_addStorage_check_right && params.p_b_w !== "Close") ? params.p_w - params.cB_addStorage_right : 0

        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.p_w - leftStorageWidth - rightStorageWidth)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshWainscotDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('back', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.position.set(-(params.p_w / 2) + rightStorageWidth , 3 , -(params.p_d / 2 + 0.155));
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshWainscotDelModel_Temp = meshWainscotDelModel.clone();
        meshWainscotDelModel_Temp.position.set(0, 0, -(params.p_d / 2 + 0.5));
        meshWainscotDelModel_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshWainscotDelModel_CSG = CSG.fromMesh(meshWainscotDelModel_Temp);

        const wainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshWainscotDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(
            wainscotTrimModel_CSG,
            new THREE.Matrix4()
        )

        // setCSGJTrimModelGeometry(CSGJTrimModel.geometry);
        // setCSGwainscotTrimModelGeometry(CSGWainscotTrimModel.geometry);

        return {
            jTrim: CSGJTrimModel.geometry,
            wTrim: CSGWainscotTrimModel.geometry
        }

    }, [params.p_d, params.p_w, params.cB_addStorage_left, params.cB_addStorage_right, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.p_b_w, const_var.newDoorsArray,wallCloseState, params.p_h]);

    useMemo(() => {
        let wallCloseValue = -1;
        let leanHeightValue = -1;

        if (params.p_b_w === 'Open') {
            wallCloseValue = -1;
        } else if (params.p_b_w === "Gable") {
            wallCloseValue = leftHeight - 0.2;
        } else if (params.p_b_w === "Extended Gable") {
            wallCloseValue = leftHeight - 3;
        } else if (params.p_b_w === "One_Fourth_Close") {
            wallCloseValue = (leftHeight * 3) / 4;
        } else if (params.p_b_w === "Half_Close") {
            wallCloseValue = leftHeight / 2;
        } else if (params.p_b_w === "Three_Fourth_Close") {
            wallCloseValue = leftHeight / 4;
        } else if (params.p_b_w === "Close" || params.p_b_w === "Half Dutch End" || params.p_b_w === "Half End") {
            wallCloseValue = 0;
        }

        if (params.add_back_lean) {
            let leanFinalHeight = params.p_h - (params.leanB_p_h + (params.leanStyle.back === "gable" ? 0.2 : (parseInt(params.b_l_t_r_pB) / 12 * params.leanB_p_w)));
            if(Object.values(const_var.wallArray["back"])[0] == params.p_b_w || params.p_b_w == "Open")
            {    
              params.p_b_w = params.p_b_wB;
              let wH = leanFinalHeight+0.2;
              setWallCloseState(params.p_h - wH);
              dispatch(setWallCloseStateWrap({'cbBackWallCloseState': params.p_h - wH}))
            }else{
                setWallCloseState(wallCloseValue);
                dispatch(setWallCloseStateWrap({'cbBackWallCloseState': wallCloseValue}))
            }
        } else {
            setWallCloseState(wallCloseValue);
            dispatch(setWallCloseStateWrap({'cbBackWallCloseState': wallCloseValue}))
        }
    
    }, [params.p_b_w, params.p_r_s, leftHeight, params.add_back_lean, params.leanB_p_h, params.leanB_p_w, params.b_l_t_r_pB, JSON.stringify(const_var.wallArray), params.leanStyle.back])

    useMemo(() => {
        if (params.cB_addStorage_check_left) {
            let overHeight = 0;
            if ((parseInt(params.cB_addStorage_left) < params.p_w / 2) || (params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right"))) {
                if (params.p_r_s === 1) {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + const_var.roofRegularDst * 2;
                } else {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                }
            } else {
                if (params.p_r_s === 1) {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + const_var.roofRegularDst * 2;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                }
            }
    
            setLeftStorageWallHeight(leftHeight + overHeight);
        } else {
            setLeftStorageWallHeight(0);
        }
    
    }, [params.cB_addStorage_check_left, params.cB_addStorage_left, params.p_r_s, params.p_r_p, params.p_w, leftHeight])

    useMemo(() => {
        if (params.cB_addStorage_check_right) {
            let overHeight = 0;
            if (parseInt(params.cB_addStorage_right) < params.p_w / 2  && !params.singleSlope) {
                if (params.p_r_s === 1) {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + const_var.roofRegularDst * 2;
                } else {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                }
            } else {
                if (params.p_r_s === 1) {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + const_var.roofRegularDst * 2;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                }
            }
    
            setRightStorageWallHeight(leftHeight + overHeight);
        } else {
            setRightStorageWallHeight(0);
        }
    
    }, [params.cB_addStorage_check_right, params.cB_addStorage_right, params.p_r_s, params.p_r_p, params.p_w, leftHeight])

    return (
        <group name='trim-group'>
            <mesh name="back-left-trim" position={[0, 0, -params.p_d / 2 - 0.23]}>
                <extrudeGeometry args={[leftTrimModel, extrudeSettings(0.23)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>
            <mesh name="back-right-trim" position={[0, 0, -params.p_d / 2 - 0.23]}>
                <extrudeGeometry args={[rightTrimModel, extrudeSettings(0.23)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>
            <mesh name="left-lean-back-right-trim" position={[0, 0, -params.p_d / 2 - 0.23]}>
                <extrudeGeometry args={[leftLeanRightTrimModel, extrudeSettings(0.15)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>
            <mesh name="right-lean-back-right-trim" position={[0, 0, -params.p_d / 2 - 0.23]}>
                <extrudeGeometry args={[RightLeanLeftTrimModel, extrudeSettings(0.15)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>
            {wallCloseStateWrap.cbLeftWallCloseState > -1 && wallCloseStateWrap.LLFrontWallCloseState > -1 && <mesh name="left-connect-trim" position={[0, 0, -params.p_d / 2 - 0.23]}>
                <extrudeGeometry args={[connectLeftTrimModel, extrudeSettings(0.15)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>}
            {wallCloseStateWrap.cbRightWallCloseState > -1 && wallCloseStateWrap.RLFrontWallCloseState > -1 &&
            <mesh name="right-connect-trim" position={[0, 0, -params.p_d / 2 - 0.23]}>
                <extrudeGeometry args={[connectRightTrimModel, extrudeSettings(0.15)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>}
            
            {(params.p_b_w === 'Open' || params.p_b_w !== 'Close') && (
                <>
                    <mesh name="back-left-storage-trim-one" position={[0, 0, -params.p_d / 2 - 0.23]}>
                        <extrudeGeometry args={[leftStorageTrimModelOne, extrudeSettings(0.08)]} />
                        <MaterialTrim visibleSection={"center"} />
                    </mesh>
                    <mesh name="back-left-storage-trim-two" position={[0.01, 0, -params.p_d / 2 - 0.225]}>
                        <extrudeGeometry args={[leftStorageTrimModelTwo, extrudeSettings(0.225)]} />
                        <MaterialTrim visibleSection={"center"} />
                    </mesh>
                    <mesh name="back-right-storage-trim-one" position={[0, 0, -params.p_d / 2 - 0.23]}>
                        <extrudeGeometry args={[rightStorageTrimModelOne, extrudeSettings(0.08)]} />
                        <MaterialTrim visibleSection={"center"} />
                    </mesh>
                    <mesh name="back-right-storage-trim-two" position={[0, 0, -params.p_d / 2 - 0.225]}>
                        <extrudeGeometry args={[rightStorageTrimModelTwo, extrudeSettings(0.225)]} />
                        <MaterialTrim visibleSection={"center"} />
                    </mesh>
                </>
            )}
            {params.p_b_w !== 'Open' && !(params.p_b_w === "Close" || params.p_b_w === "Half Dutch End" || params.p_b_w === "Half End") && params.p_j_t_end && mainTrimModel.jTrim && (
                <mesh name="right-horizontal-trim" geometry={mainTrimModel.jTrim} >
                    <MaterialTrim visibleSection={"center"} />
                </mesh>
            )}
            {params.p_w_c_n === true && ((params.p_b_w === "Close") || (params.cB_addStorage_check_left) || (params.cB_addStorage_check_right)) && mainTrimModel.wTrim && (
                <mesh name="back_leg_wainscotRightTrim" geometry={mainTrimModel.wTrim}>
                    <MaterialWainScotTrimNew visibleSection={"center"}  />
                </mesh>
            )}

            <>
                <mesh position={[0, 0, -(params.p_d / 2 + 0.15)]}>
                    <extrudeGeometry args={[dutchDelModel, extrudeSettings(0.15)]}/>
                    <MaterialTrim visibleSection={"center"} />
                </mesh>
            </>
        </group>
    )
}

export default TrimModel